import * as React from 'react';
export const usdbSvg = React.forwardRef(function usdbSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#030712',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17.257 27.936a12.11 12.11 0 0 1-2.515-.001l.38-3.564a8.515 8.515 0 0 0 1.76 0l.375 3.565Zm-5.474-4.651a8.38 8.38 0 0 0 1.615.72l-1.108 3.411a11.943 11.943 0 0 1-2.297-1.025l1.79-3.106Zm10.225 3.105c-.72.417-1.488.762-2.293 1.024l-1.11-3.408a8.385 8.385 0 0 0 1.613-.72l1.79 3.104Zm3.709-3.346a12.07 12.07 0 0 1-1.68 1.868l-2.4-2.663a8.468 8.468 0 0 0 1.18-1.313l2.9 2.108ZM9.186 20.94c.346.476.74.916 1.177 1.31l-2.4 2.661a12.077 12.077 0 0 1-1.679-1.866l2.902-2.106Zm7.627-9.646c.767.162 1.38.498 1.867 1.01.473.525.715 1.145.741 1.872h-1.88c-.051-.404-.205-.728-.486-.97-.282-.242-.652-.377-1.112-.377-.435 0-.768.094-1.024.282-.256.189-.383.459-.383.809 0 .255.077.457.23.592.153.134.37.256.652.337.281.08.716.188 1.305.296.588.12 1.1.269 1.509.444.409.175.73.445.985.795.256.35.383.822.383 1.414 0 .767-.268 1.414-.78 1.952-.511.538-1.19.875-2.007.996V22h-1.586v-1.28c-.844-.148-1.536-.5-2.047-1.065a2.93 2.93 0 0 1-.78-2.033l1.88.027c.026.472.205.849.538 1.131.332.283.766.418 1.316.418.447 0 .82-.095 1.1-.297a.995.995 0 0 0 .435-.847.803.803 0 0 0-.243-.593c-.154-.148-.384-.27-.665-.35-.281-.082-.73-.188-1.318-.323-.588-.108-1.087-.256-1.483-.444a2.399 2.399 0 0 1-.984-.822c-.256-.363-.371-.849-.371-1.455 0-.713.23-1.332.715-1.843.486-.512 1.114-.822 1.907-.956V10h1.586v1.294Zm10.93 7.186a11.9 11.9 0 0 1-.773 2.393l-3.274-1.46a8.351 8.351 0 0 0 .54-1.675l3.507.742Zm-19.98-.745c.122.584.305 1.146.542 1.68l-3.276 1.454a11.906 11.906 0 0 1-.772-2.389l3.506-.745Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 4c1.967 0 3.824.473 5.462 1.312 3.304 1.696 5.724 4.88 6.368 8.663.112.657.17 1.332.17 2.02h-3.584a8.416 8.416 0 0 0-16.832 0H4v-.083c.004-.604.053-1.198.144-1.777.603-3.857 3.05-7.112 6.409-8.83A11.95 11.95 0 0 1 16 4Z',
      fill: '#fff',
    }),
  );
});
usdbSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var usdb = {
  category: 'brand',
  colorable: false,
  name: 'usdb',
  svg: usdbSvg,
};
